<template>
  <profile-selector
    :profiles="profiles"
    :assigned="assigned"
    :show-unassign="false"
    :loading="loading"
    :count="count"
    assign-to-label="Assign to:"
    @assign="assignAssociate"
    @on-search="onSearch"
    @reached-bottom="onBottomReached"
  />
</template>
<script>

import _ from 'lodash';
import Listable from '@/components/mixins/listable';
import ProfileSelector from '@/components/Widgets/ProfileSelector';

export default {

  name: 'NewCustomerProfileSelector',
  components: {
    ProfileSelector,
  },
  mixins: [Listable],
  props: {
    mode: {
      type: String,
      default: 'loadMore',
    },
    source: {
      type: String,
      default: 'profiles',
    },
    value: {
      type: Object,
      required: true,
    },
    mountedReset: {
      type: Boolean,
      default: false,
    },
    customReset: {
      type: String,
      default: 'customReset',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    profiles() {
      return this.$store.state.profiles.items;
    },
    hasAssigned() {
      return this.$route.params.id;
    },
    loading() {
      return this.$store.state.profiles.itemStatsLoading;
    },
    count() {
      return this.$store.state.profiles.count;
    },
    assigned() {
      if (Object.keys(this.value).length === 0 && this.value.constructor === Object) {
        return this.$store.state.profiles.item;
      }
      return this.value;
    },
  },
  methods: {
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    assignAssociate(stylist) {
      this.$emit('input', stylist);
    },
    onBottomReached() {
      if (this.nextPageExists) {
        this.truePage += 1;
      }
    },
    fetchData() {
      if (this.loading) {
        console.debug('already loading');
        return;
      }
      this.requestFailed = false;
      const kwargs = {
        ...this.queryParams,
        page: this.truePage,
        search: this.search,
        page_size: this.pageSize,
      };
      this.$store.dispatch(`${this.source}/addAllOrdered`, kwargs).then((response) => {
        if (response && response.data) {
          this.nextPageExists = response.data.next != null;
        }
      }).catch((response) => {
        if (response.response == null) {
          // Network error
          this.requestFailed = true;
        } else if (response.response.status === 404) {
          // Page doesn't exist
        } else {
          // Server errro
          this.requestFailed = true;
        }
      }).finally(() => {});
    },
  },
};
</script>
<style lang="css" scoped>
</style>
